<app-loading *ngIf="contentReady"></app-loading>

<div class="bbm-page employee-list-mobile-page">
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-hero-copy">
          <span class="bbm-eyebrow">
            {{ "employees" | transloco }}
          </span>

          <h2>
            {{ "Manage your team members" | transloco }}
          </h2>

          <p>
            {{ "Manage your team members" | transloco }}
          </p>
        </div>

        <div class="bbm-hero-counter">
          <strong>
            {{ totalItems || allData.length || 0 }}
          </strong>

          <span>
            {{ "employees" | transloco }}
          </span>
        </div>

      </div>

      <div class="bbm-actions-grid bbm-hero-actions">
        <button
          type="button"
          routerLink="/addemployee"
          class="bbm-action-btn bbm-action-primary bbm-action-wide"
        >
          <i class="fa-solid fa-plus"></i>

          <span>
            {{ "New employee" | transloco }}
          </span>
        </button>
      </div>

    </section>

    <!-- EMPTY STATE -->
    <section
      class="bbm-empty-state"
      *ngIf="!contentReady && noData"
    >
      <i class="fa-solid fa-user-slash"></i>

      <h4>
        {{ "No data found" | transloco }}
      </h4>

      <p>
        {{ "No employees available" | transloco }}
      </p>
    </section>

    <!-- EMPLOYEE LIST -->
    <section
      class="bbm-ticket-list"
      *ngIf="!contentReady && !noData"
    >
      <article
        class="bbm-ticket"
        *ngFor="let element of allData; trackBy: trackByEmployeeId"
      >

        <!-- CARD TOP -->
        <div class="bbm-ticket-top">

          <div class="bbm-main-info">

            <div class="bbm-avatar employee-list-avatar">
              <img
                src="/assets/emploees.png"
                [alt]="'Employee' | transloco"
              >
            </div>

            <div class="bbm-copy">
              <span>
                {{ "Employee" | transloco }}
              </span>

              <h3>
                {{ element.name || '-' }}
              </h3>

              <div class="bbm-badges-row">
                <span class="bbm-badge">
                  <i class="fa-solid fa-briefcase"></i>

                  {{ element.job_title || '-' }}
                </span>
              </div>
            </div>

          </div>

          <!-- DROPDOWN -->
          <div class="dropdown bbm-ticket-menu">
            <button
              type="button"
              class="bbm-menu-btn"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              [attr.aria-label]="'Options' | transloco"
            >
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>

            <ul class="dropdown-menu dropdown-menu-end">

              <li *ngIf="!isSubAdmin">
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="showEmployee(element)"
                >
                  <i class="fa-regular fa-eye"></i>

                  <span>
                    {{ "employee details" | transloco }}
                  </span>
                </button>
              </li>

              <li>
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="edit(element)"
                >
                  <i class="fa-regular fa-pen-to-square"></i>

                  <span>
                    {{ "Edit" | transloco }}
                  </span>
                </button>
              </li>

              <li *ngIf="!isSubAdmin">
                <button
                  type="button"
                  class="dropdown-item bbm-dropdown-danger"
                  (click)="deleteitem(element.id)"
                >
                  <i class="fa-regular fa-trash-can"></i>

                  <span>
                    {{ "Delete" | transloco }}
                  </span>
                </button>
              </li>

            </ul>
          </div>

        </div>

        <!-- EMPLOYEE DETAILS -->
        <div class="bbm-details-grid">

          <!-- SALARY -->
          <div class="bbm-detail-chip bbm-detail-success bbm-detail-wide">
            <i class="fa-solid fa-money-bill-wave"></i>

            <span>
              {{ "salary" | transloco }}
            </span>

            <strong class="bbm-money-value">
              {{ element.salary || 0 }}
              {{ "egp" | transloco }}
            </strong>
          </div>

          <!-- PHONE -->
          <div class="bbm-detail-chip">
            <i class="fa-solid fa-phone"></i>

            <span>
              {{ "phone" | transloco }}
            </span>

            <strong>
              {{ element.phone || '-' }}
            </strong>
          </div>

          <!-- NATIONAL ID -->
          <div class="bbm-detail-chip">
            <i class="fa-solid fa-id-card"></i>

            <span>
              {{ "grov_id" | transloco }}
            </span>

            <strong>
              {{ element.national_id || '-' }}
            </strong>
          </div>

          <!-- ADDRESS -->
          <div class="bbm-detail-chip bbm-detail-wide">
            <i class="fa-solid fa-location-dot"></i>

            <span>
              {{ "address" | transloco }}
            </span>

            <strong>
              {{ element.address || '-' }}
            </strong>
          </div>

        </div>

        <!-- ACTIONS -->
        <div class="bbm-actions-grid">

          <button
            type="button"
            class="bbm-action-btn bbm-action-primary bbm-action-wide"
            (click)="showEmployee(element)"
          >
            <i class="fa-regular fa-eye"></i>

            <span>
              {{ "employee details" | transloco }}
            </span>

            <i class="fa-solid fa-arrow-right employee-details-arrow"></i>
          </button>

        </div>

      </article>
    </section>

    <!-- SCROLL LOADER -->
    <div
      class="bbm-loader"
      *ngIf="loadingMore"
    >
      <span
        class="bbm-loader-spinner"
        aria-hidden="true"
      ></span>

      <span>
        {{ "Loading" | transloco }}...
      </span>
    </div>

    <!-- END STATE -->
    <div
      class="bbm-end-state"
      *ngIf="
        !contentReady &&
        !loadingMore &&
        !noData &&
        !hasMorePages
      "
    >
      {{ "No more data" | transloco }}
    </div>

  </div>
</div>
